import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateAIConversationChatMessage } from './useAIConversationChatMessageQuery';

export function useDeleteAIConversationMessageFeedbackMutation({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: () => void;
} = {}) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			conversationId,
			messageId,
			impersonationContext,
		}: {
			conversationId: string;
			messageId: string;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync<Api.AIChatMessage>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `aiconversation/${conversationId}/chatMessage/${messageId}/feedback`,
					impersonationContext,
				}),
				'DELETE',
				null
			);
		},
		onError,
		onSuccess: (_, variables) => {
			invalidateAIConversationChatMessage(variables.conversationId);
			onSuccess?.();
		},
	});
}
